import script from "./CompanyUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&setup=true&lang=js"

import "./CompanyUsers.vue?vue&type=style&index=0&id=6df7951e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df7951e"]])

export default __exports__